export let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["PRIMARY"] = "primary";
  TYPE_OPTIONS["SECONDARY"] = "secondary";
  return TYPE_OPTIONS;
}({});
export let TYPE_AS = /*#__PURE__*/function (TYPE_AS) {
  TYPE_AS["TH"] = "th";
  TYPE_AS["TD"] = "td";
  return TYPE_AS;
}({});